const RUM_BOOTSTRAP_EVENT = "sitebuilder:datadog-bootstrap";
const MAX_PENDING_RUM_ERRORS = 32;
type PendingRumError = { error: Error; data: Record<string, unknown> };
const pending: PendingRumError[] = [];
let listening = false;

const deliver = ({ error, data }: PendingRumError) => {
  try {
    window.DD_RUM?.onReady(() => {
      try {
        window.DD_RUM?.addError(error, { data });
      } catch {
        // The browser agent must not break page rendering.
      }
    });
  } catch {
    // The browser agent must not break page rendering.
  }
};

const flush = () => {
  if (typeof window.DD_RUM?.onReady !== "function") return;
  window.removeEventListener(RUM_BOOTSTRAP_EVENT, flush);
  listening = false;
  for (const report of pending.splice(0)) deliver(report);
};

/** Buffer chosen RUM payloads; callers must never pass a raw blade exception. */
export const reportSiteBuilderRumError = (
  error: Error,
  data: Record<string, unknown>,
) => {
  if (typeof window === "undefined") return;
  const report = { error, data };
  if (typeof window.DD_RUM?.onReady === "function") {
    deliver(report);
    return;
  }
  if (pending.length === MAX_PENDING_RUM_ERRORS) pending.shift();
  pending.push(report);
  if (!listening) {
    listening = true;
    window.addEventListener(RUM_BOOTSTRAP_EVENT, flush);
  }
};
